import React from 'react';

import { MenuItem, styled, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import ExcelFile from 'components/SvgComponents/ExcelFile';
import ChevronRight from 'components/SvgComponents/icons/ChevronRight';
import Download from 'components/SvgComponents/icons/Download';
import LogFile from 'components/SvgComponents/icons/LogFile';
import QRCode from 'components/SvgComponents/icons/QRCode';
import PdfFile from 'components/SvgComponents/PdfFile';
import { fileType } from 'utils/constants';

const Typography_CustomMargin = styled(Typography, {
  shouldForwardProp: prop => prop !== 'withMargin',
})(({ theme, withMargin }) => ({
  marginRight: withMargin ? theme.spacing(2) : 0,
}));

const ExcelFile_WithMargin = styled(ExcelFile)(({ theme }) => ({
  marginInlineEnd: theme.spacing(2),
}));
const PdfFile_WithMargin = styled(PdfFile)(({ theme }) => ({
  marginInlineEnd: theme.spacing(2),
}));
const LogFile_WithMargin = styled(LogFile)(({ theme }) => ({
  marginInlineEnd: theme.spacing(2),
}));
const QRCode_WithMargin = styled(QRCode)(({ theme }) => ({
  marginInlineEnd: theme.spacing(2),
  color: theme.palette.icon.main,
}));
const Download_WithMargin = styled(Download)(({ theme }) => ({
  marginInlineEnd: theme.spacing(2),
  color: theme.palette.icon.main,
}));

const MultiExportButtonMenuItem = ({ label, icon, tag, hasChildren = false, onClick }) => {
  const renderIcon = icon => {
    if (icon === fileType.excel) {
      return <ExcelFile_WithMargin />;
    }
    if (icon === fileType.pdf) {
      return <PdfFile_WithMargin />;
    }
    if (icon === fileType.log) {
      return <LogFile_WithMargin />;
    }
    if (icon === fileType.qrcode) {
      return <QRCode_WithMargin size={16} />;
    }
    if (icon === fileType.download) {
      return <Download_WithMargin size={16} />;
    }
    return '';
  };

  return (
    <MenuItem
      key={label}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      {renderIcon(icon)}
      <Typography_CustomMargin variant="body" withMargin={!!label}>
        {label}
      </Typography_CustomMargin>
      {tag}
      {hasChildren && <ChevronRight width={18} height={18} />}
    </MenuItem>
  );
};

MultiExportButtonMenuItem.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  tag: PropTypes.string,
  hasChildren: PropTypes.bool,
  onClick: PropTypes.func,
};

export default MultiExportButtonMenuItem;
